import NProgress from 'nprogress'
import store from '@/store/index'

export const beforeResolve = (to, from, next) => {
  if (from.name) {
    NProgress.start()
  }
  next()
}

export const beforeEach = (to, from, next) => {
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth)
  const guestOnly = to.matched.some(record => record.meta.guestOnly)
  const permission = to.matched.some(record => record.meta.permission)
	const isAuthenticated = store.getters.isAuthenticated

  if (requiresAuth && !isAuthenticated) {
    return next({ name: 'auth.admin' })
	} 
	else if (guestOnly && isAuthenticated) {
    return next({ name: 'dashboard' })
	} 
	else if (permission && !store.getters.userCan(to.meta.permission)) {
    console.error('Access denied! User cannot ' + to.meta.permission) // TODO - Remove this!
    return next({ name: 'dashboard' })
	} 
	else {
    return next()
  }
}

export const afterEach = () => {
  NProgress.done()
}
